import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { DatadogService } from '../../service';

export type ListMonitorsConfig = typeof ListMonitorsConfig._.Config;

export const ListMonitorsConfig = IntegrationConfig.make({
  service: DatadogService,
  name: Integration_Handler_Names_Enum.ListMonitors,
  configSchema: z.object({
    monitorNamePatternFilter: patternFilterSchema.optional(),
  }),
});
